export default __webpack_public_path__ + "static/media/ico-mysql-score-low.4843b7a4.svg";